export default __webpack_public_path__ + "images/WV.60d564c.png";